import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Person from "@/shared/model/person";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {computed} from "vue";
import {ref} from "vue";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {gridActionFailure} from "@/shared/services/api";

interface Props {
  data?: Person[],
  selected?: (person?: Person) => void,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonListComponent',
  props: {
    data: { default: undefined },
    selected: { type: Function, default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const _grid = ref<InstanceType<typeof GridComponent> | null>(null)

const sortOptions = {columns: [{field: 'personName', direction: 'Ascending'}]}
const pageSettings = {pageSize: 10, pageSizes: ["All", 10, 25, 50, 100]}


const _dataManager = ref<DataManager | undefined>(undefined)

function dataBound() {
  //_grid.value?.hideScroll();
}

const _data = computed(() => {
  if (props.data) {
    if (!_dataManager.value)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      _dataManager.value = new DataManager(props.data)
    return _dataManager.value
  }
  return undefined
})


function refresh() {
  _grid.value?.refresh()
}

function onSelected(args: any) {
  if (props.selected && args.data) {
    props.selected(args.data)
  }
}

function onDeselected(args: any) {
  if (props.selected && args.isInteracted) {
    props.selected(undefined)
  }
}


__expose({
  refresh
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(GridComponent), {
      id: "personList",
      ref_key: "_grid",
      ref: _grid,
      "data-source": _data.value,
      "allow-paging": true,
      "data-bound": dataBound,
      "allow-sorting": true,
      "sort-settings": sortOptions,
      width: "100%",
      "row-selected": onSelected,
      "row-deselected": onDeselected,
      "action-failure": _unref(gridActionFailure),
      "page-settings": pageSettings
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ColumnsDirective), null, {
          default: _withCtx(() => [
            _createVNode(_unref(ColumnDirective), {
              field: "personType",
              "header-text": "",
              "auto-fit": true,
              template: 'cTemplate'
            }, {
              cTemplate: _withCtx(({data}) => [
                _withDirectives(_createVNode(SogIcon, { icon: "mdi-account" }, null, 512), [
                  [_vShow, data.personType==='Natural']
                ]),
                _withDirectives(_createVNode(SogIcon, { icon: "mdi-office-building" }, null, 512), [
                  [_vShow, data.personType==='Legal']
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ColumnDirective), {
              field: "personName",
              "header-text": "Name",
              "auto-fit": true
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "action-failure"])
  ]))
}
}

})